document.addEventListener('DOMContentLoaded', () => {
  const targetSelector = '.rfq-success-message';

  const observer = new MutationObserver((mutations, obs) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (
          node.nodeType === 1 &&
          (node.matches(targetSelector) || node.querySelector(targetSelector))
        ) {
          // Push event to dataLayer
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'ProductFormQuoteSubmitted',
            productFormConversionLabel: 'mr3GCIOJ0_gaEL_wmpM_'
          });

          // Send hit
          gtag('event', 'conversion', {
            'send_to': 'AW-16951719999/mr3GCIOJ0_gaEL_wmpM_'
          });

          obs.disconnect();
          return;
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});